import { supabase } from '../lib/supabase';
import { isServer, getApiBaseUrl, logger } from '../lib/utils';

export interface FunnelStep {
  id?: number;
  session_id: string;
  step: string;
  form_data?: any;
  errors?: any;
  url_query_string?: string;
  created_at?: string;
}


// Use the utility function to get the API base URL
const API_BASE_URL = getApiBaseUrl();

/**
 * Track the completion of a funnel step
 */
export async function trackStepCompletion(
  sessionId: string,
  step: string,
  formData: any = {},
  urlQueryString?: string
) {
  try {
    if (isServer()) {
      logger.warn('trackStepCompletion should not be called server-side');
      return null;
    }

    const response = await fetch(`${API_BASE_URL}/track-step`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId,
        step,
        formData,
        urlQueryString
      }),
    });

    if (!response.ok) {
      logger.error('Failed to track step completion:', await response.text());
      return null;
    }

    return await response.json();
  } catch (error) {
    logger.error('Error tracking step completion:', error);
    return null;
  }
}

/**
 * Track validation errors in a funnel step
 */
export async function trackStepErrors(
  sessionId: string,
  step: string,
  errors: any,
  formData: any = {},
  urlQueryString?: string
) {
  try {
    if (isServer()) {
      logger.warn('trackStepErrors should not be called server-side');
      return null;
    }

    const response = await fetch(`${API_BASE_URL}/track-step`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId,
        step,
        errors,
        formData,
        urlQueryString
      }),
    });

    if (!response.ok) {
      logger.error('Failed to track step errors:', await response.text());
      return null;
    }

    return await response.json();
  } catch (error) {
    logger.error('Error tracking step errors:', error);
    return null;
  }
}


